var InsertVideoModal = {
	label: "Insert a video by pasting the embed snippet in the box below.",
	helpText: "The embed snippet usually starts with \"<iframe …\""
};
var _en = {
	InsertVideoModal: InsertVideoModal
};

export { InsertVideoModal, _en as default };
